/* eslint-disable @typescript-eslint/no-unused-vars */
import { useState, useEffect } from 'react';
import request from '../../utils/request';
import TableSearch from '../common/TableSearch';
import loader from '../common/loader.gif';
import PageHeader from '../common/PageHeader';
import VisibilityIcon from '@mui/icons-material/Visibility';

import {
  Tooltip,
  Divider,
  Box,
  Card,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  TableContainer,
  useTheme,
  Grid,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button
} from '@mui/material';
import SnackbarAlert from '../common/SnackbarAlert';
import { checkPermission } from '../../utils/permission';
import NoDataAvailable from '../common/NoDataAvailable';
import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import DeleteAlert from '../common/DeleteAlert';
import Links from '@mui/material/Link';
import TableSearchWithIcon from '../common/TableSearchWithIcon';

// eslint-disable-next-line

const PolicyLodList = ({ showCreateEditForm, editDatas }) => {
  const [isLoading, setLoading] = useState(true);
  const theme = useTheme();
  const [requirementsList, setRequirementsList] = useState<any>([]);
  const [offset, setOffset] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [totalCount, setTotalCount] = useState<number>(0);
  interface SearchState {
    text: string;
    triggerId: number;
  }
  const [search, setSearch] = useState<SearchState>({
    text: '',
    triggerId: Date.now(),
  });

  const [enquiryCreatePermission, setEnquiryCreatePermission] = useState(false);
  const [enquiryDeletePermission, setEnquiryDeletePermission] = useState(false);
  const [claimTemplateCreatePermission, setclaimTemplateCreatePermission] =
    useState(false);
  const [deleteData, setDeleteData] = useState<any>([]);
  const [deleteopen, setDeleteOpen] = useState(false);
  const [lodData, setLodData] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [showSnackBarAlert, setShowSnackBarAlert] = useState({
    status: false,
    type: 'success',
    message: null
  });

  const handleChangePage = (event, newPage) => {
    setOffset(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+parseInt(event.target.value));
    setOffset(0);
  };

  const changeSearch = (searchValue) => {
    setOffset(0);
    setSearch(searchValue);
  };

  const getRequirementList = async () => {
    request({
      url: 'listOfRequirements/getListOfRequirementsList',
      method: 'POST',
      data: {
        search: search?.text,
        orderColumn: 'id',
        orderDirection: 'DESC',
        offset: offset,
        limit: rowsPerPage
      }
    })
      .then((response) => {
        setRequirementsList(response['data']);
        setTotalCount(response['count']);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const handleSnackbarClose = () => {
    setShowSnackBarAlert({ status: false, type: null, message: null });
  };

  const handleOpen = (requirement) => {
    setLodData(requirement);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  useEffect(() => {
    checkRolePermission();
    checkUpdateRolePermission();
    checkDeleteRolePermission();
    checkRoleCreatePermission();
  }, []);

  const checkRolePermission = async () => {
    await checkPermission('Enquiry', 'Create').then((permission) => {
      setEnquiryCreatePermission(permission);
    });
    await checkPermission('Enquiry', 'AssignUser').then((permission) => {
      // setEnquiryAssignPermission(permission);
    });
  };

  const checkUpdateRolePermission = async () => {
    await checkPermission('Enquiry', 'Update').then((permission) => {
      // setEnquiryUpdatePermission(permission);
    });
  };

  const checkDeleteRolePermission = async () => {
    await checkPermission('Enquiry', 'Delete').then((permission) => {
      setEnquiryDeletePermission(permission);
    });
  };

  const checkRoleCreatePermission = async () => {
    await checkPermission('Rfq', 'Create').then((permission) => {
      setclaimTemplateCreatePermission(permission);
    });
  };

  useEffect(() => {
    getRequirementList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage, offset, search]);

  const handleDeleteOpen = (requirement) => {
    setDeleteData(requirement);
    setDeleteOpen(true);
  };
  console.log('deleteData', lodData);

  return (
    <>
      <Box sx={{ width: '100%', typography: 'body1' }}>
        <SnackbarAlert
          showSnackBarAlert={showSnackBarAlert}
          handleSnackbarClose={handleSnackbarClose}
        />
        <Card>
          <Grid container m={1}>
            <Grid item xs={8}>
              <PageHeader
                title={'LOR/LOD'}
                button_text={'Create LOR/LOD'}
                showCreateEditForm={showCreateEditForm}
                createPermission={enquiryCreatePermission}
              />
            </Grid>

            <Grid item xs={4}>
              <TableSearchWithIcon
                changeSearch={changeSearch}
                deafultSearchValue={search.text}
              />
            </Grid>
          </Grid>
          <Divider />
          {isLoading ? (
            <TableContainer>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <img
                        alt="loader"
                        src={loader}
                        className="loader"
                        width={100}
                        height={100}
                      />
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
          ) : (
            <>
              <TableContainer>
                {requirementsList?.length > 0 && !isLoading ? (
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>Product</TableCell>
                        <TableCell>Title</TableCell>
                        <TableCell>Actions</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {requirementsList.map((requirement) => (
                        <TableRow hover key={requirement.id}>
                          <TableCell>
                            <Typography variant="body2">
                              {requirement.policyProduct?.name || 'N/A'}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            <Typography variant="body2">
                              {requirement?.title?.length <= 40 ? (
                                requirement?.title
                              ) : (
                                <p>
                                  {requirement?.title?.substring(0, 40)}
                                  ...
                                  <Tooltip
                                    placement="top-end"
                                    title={requirement?.title}
                                    arrow
                                  >
                                    <Links> Read More</Links>
                                  </Tooltip>
                                </p>
                              )}
                            </Typography>
                          </TableCell>

                          <TableCell>
                            <Box display="flex" gap={1}>
                              <Tooltip title="View More" arrow>
                                <IconButton
                                  sx={{
                                    '&:hover': {
                                      background: theme.colors.primary.lighter
                                    },
                                    color: theme.palette.primary.main
                                  }}
                                  color="inherit"
                                  size="small"
                                  onClick={() => handleOpen(requirement)}
                                >
                                  <VisibilityIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Edit">
                                <IconButton
                                  onClick={() => editDatas(requirement)}
                                  // disabled={!permissions.update}
                                  sx={{
                                    '&:hover': {
                                      background: theme.colors.primary.lighter
                                    },
                                    color: theme.palette.primary.main
                                  }}
                                >
                                  <EditTwoToneIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>

                              {/* <Tooltip title="Map Claim Template">
                                <IconButton
                                  onClick={() => setClaimFormOpen(true)}
                                  sx={{
                                    '&:hover': {
                                      background: theme.colors.primary.lighter
                                    },
                                    color: theme.palette.primary.main
                                  }}
                                >
                                  <PrivacyTipIcon fontSize="small" />
                                </IconButton>
                              </Tooltip> */}
                              <Tooltip title="Delete">
                                <IconButton
                                  onClick={() => handleDeleteOpen(requirement)}
                                  sx={{
                                    '&:hover': {
                                      background: theme.colors.error.lighter
                                    },
                                    color: theme.palette.error.main
                                  }}
                                >
                                  <DeleteTwoToneIcon fontSize="small" />
                                </IconButton>
                              </Tooltip>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                ) : (
                  <NoDataAvailable />
                )}
              </TableContainer>
              <Box p={2}>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 75, 100]}
                  component="div"
                  count={totalCount}
                  rowsPerPage={rowsPerPage}
                  page={offset}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Box>
            </>
          )}
        </Card>
        <Dialog
          fullWidth
          maxWidth="sm"
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{'LOR/LOD Details'}</DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <Typography fontWeight="bold">Product</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{lodData?.policyProduct?.name || 'N/A'}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography fontWeight="bold">Title</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{lodData?.title || 'N/A'}</Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography fontWeight="bold">Description</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>{lodData?.description || 'N/A'}</Typography>
              </Grid>

              {/* <Grid item xs={12}>
                <Typography fontWeight="bold" gutterBottom>
                  QC Checklist
                </Typography>
                {Array.isArray(lodData.qcChecklist) &&
                lodData.qcChecklist.length > 0 ? (
                  lodData.qcChecklist.map((item, index) => (
                    <Box
                      key={index}
                      mb={2}
                      pl={2}
                      borderLeft={`3px solid ${theme.palette.primary.main}`}
                    >
                      <Typography variant="subtitle1" fontWeight="600">
                        {item.requirement}
                      </Typography>
                      {Array.isArray(item.checks) && item.checks.length > 0 ? (
                        <ul
                          style={{
                            marginTop: 4,
                            marginBottom: 0,
                            paddingLeft: 20
                          }}
                        >
                          {item.checks.map((check, i) => (
                            <li key={i}>
                              <Typography variant="body2">{check}</Typography>
                            </li>
                          ))}
                        </ul>
                      ) : (
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          sx={{ pl: 2 }}
                        >
                          No checks available
                        </Typography>
                      )}
                    </Box>
                  ))
                ) : (
                  <Typography variant="body2" color="textSecondary">
                    No QC Checklist available
                  </Typography>
                )}
              </Grid> */}
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={handleClose}
              autoFocus
              variant="contained"
              color="error"
            >
              Close
            </Button>
          </DialogActions>
        </Dialog>

        <DeleteAlert
          pageContent={'LOR/LOD'}
          deleteopen={deleteopen}
          deleteName={deleteData?.title}
          deleteData={deleteData}
          refetchApi={getRequirementList}
          setDeleteOpen={setDeleteOpen}
          apiUrl={'/listOfRequirements/' + deleteData.id}
        />
      </Box>
    </>
  );
};

export default PolicyLodList;
